import { api } from "apiServer"
import { Layout } from "components/common"
import CardLive from "components/CardLive"
import CardVod from "components/CardVod"
import { Fragment, useEffect, useRef, useState } from "react"
import CardLiveShow from "components/CardLiveShow"
import TypeEvent from "utils/TypeEvent"
import CardBanner from "components/CardBanner"
import CardTopic from "components/CardTopic"
import CardChannel from "components/CardChannel"
import CardHorizontal from "components/TypeCard/CardHorizontal"
import { getCookieValue } from "lib/func"
import config from "lib/config"
import Image from "next/image"

function Component({ lists, slug, video }) {
  const { name, thumbnail_banner, display_type, color, type_block, description } = video
  const [rows, setRows] = useState(lists)
  const [_slug, setSlug] = useState(slug)
  const [_video, setVideo] = useState(video)
  const [loading, setLoading] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const pageNum = useRef(1)
  const maxCount = useRef(24)
  const [lastFetchTime, setLastFetchTime] = useState(Date.now())
  let calling = false

  const [scroll, setScroll] = useState(null)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setScroll(true)
      } else {
        setScroll(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    function onScroll() {
      if (window.scrollY + window.innerHeight > (document.body.scrollHeight * 6) / 7) {
        if (!calling) {
          setLoading(true)
        }
      } else {
        setLoading(false)
      }
    }

    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  const fetchData = async () => {
    try {
      const timestamp = Date.now()

      const accessToken = getCookieValue("accessToken")

      const { data, block } = await api.getFullByBlock(accessToken, _slug, {
        page_num: 1,
        page_size: 20
      })
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("lastFetchTime", timestamp)
      }

      setRows(data)
      setVideo(block)
      setLastFetchTime(timestamp)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchMoreData() {
    const accessToken = getCookieValue("accessToken")

    try {
      pageNum.current = pageNum.current + 1
      const { data, count } = await api.getFullByBlock(accessToken, _slug, {
        page_num: pageNum.current,
        page_size: 20
      })
      maxCount.current = count
      setRows([...rows, ...data])
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        const timestamp = Date.now()
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetchMoreData()
  }, [loading])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = Date.now()
        const lastFetchTime = sessionStorage.getItem("lastFetchTime") || 0
        const timeElapsed = currentTime - lastFetchTime
        if (timeElapsed >= config.TIME_REQUEST_HOME_PAGE) {
          fetchData()
          // fetchMoreData()
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [lastFetchTime])

  let isDragging = false
  let startX

  function handleDragStart(e) {
    e.preventDefault()
    isDragging = true
    startX = e.pageX || e.touches[0].pageX
  }

  function handleDrag(e) {
    if (!isDragging) return
    const x = e.pageX || e.touches[0].pageX
    const scrollLeft = e.currentTarget.scrollLeft
    e.currentTarget.scrollLeft = scrollLeft - (x - startX)
    startX = x
  }

  function handleDragEnd() {
    isDragging = false
  }

  return (
    <div className="flex flex-col gap-8 mb-8 mr-8 max-sm:gap-4 max-lg:mr-4 max-lg:ml-4 max-lg:mt-5 max-lg:gap-4 ">
      {type_block === 6 ? (
        <div
          className={`relative fix_img rounded-3xl overflow-hidden max-sm:rounded-none ${
            isMobile ? " draggable flex sticky top-[58.75px] z-30 bg-[#131313]" : ""
          }`}
          onMouseDown={(e) => handleDragStart(e)}
          onMouseMove={(e) => handleDrag(e)}
          onMouseUp={() => handleDragEnd()}
          onMouseLeave={() => handleDragEnd()}
        >
          <MyImage
            name={name}
            thumbnail={thumbnail_banner}
            description={description}
            backgroundColor={color}
            isMobile={isMobile}
            scroll={scroll}
          />
        </div>
      ) : (
        <div className="text-[26px] text-[#fafaf9] font-semibold max-sm:text-[20px] max-sm:px-4">{name}</div>
      )}
      <div className="flex flex-col gap-3.5 max-sm:px-4">
        {type_block === 6 && <span className="text-[24px] text-white font-semibold">Video</span>}
        <div
          className={`grid max-lg:grid-cols-2 max-lg:gap-x-3 max-lg:gap-y-5 ${
            isMobile && display_type === 1 && type_block === 2
              ? "grid-cols-2 gap-6"
              : isMobile
              ? "gap-6"
              : rows.some((item) => item.type === TypeEvent.TOPIC)
              ? "grid-cols-2 gap-6 2xl:grid-cols-3"
              : display_type === 1 && type_block === 6
              ? "grid-cols-4 gap-6"
              : display_type === 1
              ? "grid-cols-6 gap-6"
              : type_block === 7
              ? "grid-cols-4 gap-x-6 gap-y-5"
              : "grid-cols-3 gap-6 2xl:grid-cols-4"
          }`}
        >
          {rows?.length > 0 &&
            rows?.map((item) => {
              const { id, type, block_type } = item
              return (
                <Fragment key={id}>
                  {type === TypeEvent.LIVE && <CardLive {...item} display_type={display_type} />}
                  {type === TypeEvent.LIVESHOW && block_type === 1 && (
                    <CardLiveShow {...item} display_type={display_type} />
                  )}
                  {type === TypeEvent.VOD && (
                    <CardVod {...item} display_type={display_type} showTime={false} customGrid={true} />
                  )}
                  {type === TypeEvent.BANNER && <CardBanner {...item} display_type={display_type} showTime={false} />}
                  {type === TypeEvent.TOPIC && <CardTopic {...item} display_type={display_type} showTime={false} />}
                  {type === TypeEvent.STORY && (
                    <CardHorizontal {...item} display_type={display_type} showTime={false} />
                  )}
                  {block_type === 7 && <CardChannel {...item} display_type={display_type} showTime={false} />}
                </Fragment>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default Component
Component.Layout = Layout

function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  if (!thumbnail) return "/placeholder_video.svg"
  return `${base_url}${size}/${thumbnail}`
}

function MyImage({ base_url, thumbnail, name, description, backgroundColor, isMobile, scroll }) {
  return (
    <div className="relative rounded-3xl overflow-hidden max-sm:rounded-none">
      {isMobile && scroll ? (
        <></>
      ) : (
        <div
          className="w-full h-[132px] max-sm:h-[42px] absolute bottom-0 left-0"
          style={{
            background: `linear-gradient(180deg, transparent 0%, ${backgroundColor} 84.66%, ${backgroundColor} 100%)`
          }}
        ></div>
      )}
      <div className={`bottom-0 left-0 w-full ${isMobile && scroll ? "" : "absolute"}`}>
        <div className="flex flex-col w-full gap-1 px-5 pb-5 max-sm:pb-3 max-sm:px-3">
          <div className="font-semibold text-2xl text-[#fafaf9] max-sm:line-clamp-2">{name}</div>
          <div className="font-normal text-sm text-secondary line-clamp-1 max-sm:hidden">{description}</div>
        </div>
      </div>

      {isMobile && scroll ? (
        <></>
      ) : (
        <div className="fix_img">
          <img
            placeholder="blur"
            className="w-full rounded-3xl h-[358px] object-cover max-sm:rounded-none"
            src={renderUrl(base_url, thumbnail, "1920x800") || "/placeholder_banner.svg"}
            width={1578}
            height={358}
            alt={name}
          />
        </div>
      )}
    </div>
  )
}

export async function getServerSideProps({ req, query, res }) {
  let lists = [],
    video = {},
    totalPage = 0
  const { cookies } = req
  const { slug } = query

  try {
    const { data, block, total_page } = await api.getFullByBlock(cookies?.accessToken, slug, {
      page_num: 1,
      page_size: 20
    })
    totalPage = total_page
    lists = data
    video = block
  } catch (error) {
    console.log(error.response)
  }
  return { props: { lists, video, slug, totalPage } }
}
